import { SelectOption } from "@kanda-libs/ks-component-ts";

export const APR_CHANGED_OPTIONS: SelectOption[] = [
  {
    name: "",
    value: "",
  },
  {
    name: "Yes",
    value: "yes",
  },
  {
    name: "No",
    value: "no",
  },
];
